export default "__VITE_ASSET__1XQkij8e__"